import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AmparosService } from './shared/amparos.service';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RamoService } from '../ramo/shared/ramo.service';
import 'datatables.net';
import 'datatables.net-bs4';
import * as $ from 'jquery';
import { Amparos } from './shared/amparos.model';
import { Select2OptionData } from 'ng-select2';


@Component({
  selector: 'app-amparos',
  templateUrl: './amparos.component.html',
  styleUrls: ['./amparos.component.css']
})
export class AmparosComponent implements OnInit {
  formAmparo: FormGroup;

  edit: boolean;
  idEdit: number;
  valueSelected: string = "";
  datatable: any;

  ListRamos: Array<Select2OptionData> = [];
  ListAmparos: Amparos[] = [];

  constructor(private amparosService: AmparosService,
    private toastr: ToastrService,
    private ramoService: RamoService,
    private _fb: FormBuilder,
    private chRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.loadRamos();
    this.initForm();
  }

  initForm() {
    this.formAmparo = this._fb.group({
      idAdmAmparo: 0,
      nombre: ["", [Validators.required]],
      ramo: [[''], [Validators.required]],
      AdmRamoAmparo: null,
    })
    this.toastr.warning ("Para consultar los amparos, porfavor seleccione un ramo")//TODO: Validar Trasnlate
  }

  onSubmit() {
    this.insertAmparo();
  }

  refreshListByramo(event) {
    this.valueSelected = event;
    this.edit = false;
    if (this.valueSelected == "") {
      this.toastr.warning("Para consultar los amparos, porfavor seleccione un ramo")//TODO: Validar Trasnlate
    } else {
      this.getAmparos(this.valueSelected);
      //this.amparosService.getAmparosByRamo(this.formAmparo.get("ramo").value);
    }

  }

  getAmparos(ramo: any) {
    this.amparosService.getAmparosByRamo(ramo).then(r => {

      if ($.fn.dataTable.isDataTable('#datatable')) {
        this.datatable.destroy();
      }

      this.ListAmparos = r as Amparos[];

      this.chRef.detectChanges();

      const table: any = $('table');
      this.datatable = table.DataTable({
        responsive: true
      })

    });
  }

  getAmparo(id: number) {
    this.amparosService.getAmparoById(id)
  }

  deleteAmparo(id: number) {
    this.amparosService.deleteAmparo(id).then(r => {
      this.refreshListByramo(this.valueSelected);
      this.toastr.error('Eliminado correctamente');
    });
  }

  editAmparo(nombreEdit, id) {
    this.edit = true;
    this.idEdit = id;
    this.formAmparo.patchValue({
      nombre: nombreEdit,
      ramo: this.valueSelected
    });
  }

  resetForm() {
    this.formAmparo.reset();
  }

  updateAmparo() {
    let valueSubmit = Object.assign({}, this.formAmparo.value);
    valueSubmit = Object.assign(valueSubmit, {
      AdmRamoAmparo: [],
      idAdmAmparo: this.idEdit
    });
    this.amparosService.updateAmparo(valueSubmit, this.idEdit).then(r => {
      this.toastr.success('Actualizado correctamente'); this.refreshListByramo(this.valueSelected);
      this.resetForm()
    });
    this.edit = false;
  }

  insertAmparo() {
    let valueSubmit = Object.assign({}, this.formAmparo.value);
    valueSubmit = Object.assign(valueSubmit, {
      AdmRamoAmparo: [{ idAdmRamo: valueSubmit.ramo }]
    });

    this.amparosService.postAmparo(valueSubmit).then(
      r => { this.toastr.success("Dato insertado correctamente"); this.refreshListByramo(this.valueSelected) }, e => {
        this.toastr.error("this it's a Error"); //TODO: Cambiar mensaje por la versión con translate
      }
    )
  }

  loadRamos() {
    this.ramoService.getRamoAplicaPac().then(r => {
      let list: Select2OptionData[] = [];
      if (this.ramoService.listRamo != null) {
        list.push({ id: '0', text: 'Seleccione' });
        this.ramoService.listRamo.forEach(item => {
          list.push({ id: item.idAdmRamo.toString(), text: item.nombre });
        });
      }

      this.ListRamos = list;
    });
  }
}
